"use strict";

import breakpoints from "../helpers/breakpoints";

const initializeCustomTooltipItemsListener = () => {
    const $document = $(document);

    $document.on("click", ".js-tooltip-trigger", function () {
        if ($(window).width() >= breakpoints.lg) {
            return;
        }

        const $tooltipTrigger       = $(this);
        const $tooltipTargetContent = $($tooltipTrigger.data("target-content"));

        $tooltipTargetContent.toggleClass("show");
    });

    $document.on("mouseover", ".js-tooltip-trigger", function () {
        if ($(window).width() < breakpoints.lg) {
            return;
        }

        const $tooltipTrigger       = $(this);
        const $tooltipTargetContent = $($tooltipTrigger.data("target-content"));

        $tooltipTargetContent.toggleClass("show", true);
    });

    //Hide the tooltip when the mouse leave the trigger or the tooltip content element, only applicable to desktop screen size.
    $document.on("mouseleave", ".js-tooltip-content", function () {
        if ($(window).width() < breakpoints.lg) {
            return;
        }

        const $tooltipContent = $(this);

        $tooltipContent.toggleClass("show", false);
    });
};

const initializeListeners = () => {
    initializeCustomTooltipItemsListener();
};

export default initializeListeners;
